(function () {
  var STATES = ['in-stock', 'order-in', 'long-lead'];

  function setup(badge) {
    if (badge.getAttribute('data-ready')) return;
    badge.setAttribute('data-ready', 'true');
    var map = {};
    try {
      map = JSON.parse(badge.getAttribute('data-variants') || '{}');
    } catch (e) {}
    var labels = {
      'in-stock': badge.getAttribute('data-label-in-stock') || '',
      'order-in': badge.getAttribute('data-label-order-in') || '',
      'long-lead': badge.getAttribute('data-label-long-lead') || '',
    };
    var stock = {};
    try {
      stock = JSON.parse(badge.getAttribute('data-stock') || '{}');
    } catch (e) {}
    var noteTemplate = badge.getAttribute('data-note') || '';
    var note =
      badge.nextElementSibling && badge.nextElementSibling.matches('[data-stock-badge-note]') ? badge.nextElementSibling : null;
    var scope = badge.closest('.shopify-section') || document;

    function currentId() {
      var input = scope.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (input) return input.disabled ? null : input.value || null;
      var m = window.location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : null;
    }

    /* "Only 1 in stock. Extra quantity: 7-10 Days Dispatch" for a counted size with a little stock */
    function showNote(state, id) {
      if (!note) return;
      var entry = id ? stock[id] : null;
      if (state === 'in-stock' && entry && labels[entry[1]] && noteTemplate) {
        note.textContent = noteTemplate.replace('[count]', entry[0]).replace('[label]', labels[entry[1]]);
        note.hidden = false;
      } else {
        note.textContent = '';
        note.hidden = true;
      }
    }

    function show(state, id) {
      showNote(state, id);
      STATES.forEach(function (s) {
        badge.classList.remove('stock-badge--' + s);
      });
      if (state) {
        badge.classList.add('stock-badge--' + state);
        badge.textContent = labels[state];
        badge.hidden = false;
      } else {
        badge.textContent = '';
        badge.hidden = true;
      }
    }

    function apply() {
      var id = currentId();
      /* The map covers only a product's first 250 variants; leave others to tsp:variant-change */
      if (id && !(id in map)) return;
      show(id ? map[id] || '' : '', id);
    }

    /* The Tool product page announces its variant directly (with its stock state when the variant
       was fetched from Shopify); other forms are read after a change */
    scope.addEventListener('tsp:variant-change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (variant && typeof variant.stockState === 'string') map[variant.id] = variant.stockState;
      show(variant ? map[variant.id] || '' : '', variant ? variant.id : null);
    });
    scope.addEventListener('change', function () {
      setTimeout(apply, 60);
    });
    window.addEventListener('popstate', function () {
      setTimeout(apply, 60);
    });
    apply();
  }

  function init() {
    document.querySelectorAll('[data-stock-badge]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
